import React from "react";
import { NavLink } from 'react-router-dom';

export default function NavSidebarItem(props) {
  return  (
    <li className='nav-sidebar__item'><NavLink className='nav-sidebar__link' activeClassName='nav-sidebar__link_active' to={props.link}> {props.name} </NavLink></li>
  )
}
